import WhatsAppChatView from './components/whatsappChatView.component';

export default function WhatsAppChatPage() {
  return <WhatsAppChatView />;
}
